export default "__VITE_ASSET__D5d4gOfX__"